import { expectEls } from "../util";

export function removeSceneElements() {
    const animDurationMs = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue(
            "--anim-duration",
        ),
    );

    const elementEls = expectEls("#game .elements > .element");
    for (const elementEl of elementEls) {
        elementEl.classList.remove("--anim-fade-in");
        elementEl.classList.add("--anim-fade-out");
        setTimeout(() => elementEl.remove(), animDurationMs);
    }
}
